import { Navigate, useLocation, useParams } from "react-router-dom";
import { all_routes as kanakkuRoutes } from "@kanakku/feature-module/router/all_routes";

function InvoiceDetailLegacyRedirect() {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (id) params.set("id", id);
  const query = params.toString();
  return <Navigate to={`${kanakkuRoutes.invoiceDetails}${query ? `?${query}` : ""}`} replace />;
}

/** Redirections legacy Suite → routes Kanakku */
export const billingLegacyRedirects = [
  { path: "/tenant/billing", element: <Navigate to={kanakkuRoutes.adminDashboard} replace /> },
  { path: "/tenant/billing/invoices", element: <Navigate to={kanakkuRoutes.invoices} replace /> },
  { path: "/tenant/billing/invoices/:id", element: <InvoiceDetailLegacyRedirect /> },
  {
    path: "/tenant/billing/invoice-templates",
    element: <Navigate to={kanakkuRoutes.invoiceTemplates} replace />,
  },
  { path: "/tenant/billing/customers", element: <Navigate to={kanakkuRoutes.customers} replace /> },
  {
    path: "/tenant/billing/credit-notes",
    element: <Navigate to={kanakkuRoutes.creditNotes} replace />,
  },
  { path: "/tenant/billing/payments", element: <Navigate to={kanakkuRoutes.payments} replace /> },
];
